module.exports = __webpack_public_path__ + "static/media/visual.e3fb7f0e.svg";